export default __webpack_public_path__ + "static/media/Tutorial-Step-2.4.a7129f18.jpg";